<section>
  <app-public-header></app-public-header>
</section>
<section>
  <div class="row">
    <div class="col-12">
      <img alt="home-info" src="./assets/images/home_info.jpg" width="100%">
    </div>
  </div>
</section>
<section class="home-page">
  <div class="container p-4">
    <div class="row">
      <div class="col-8 offset-2 text-center">
        <h3> {{'content-introduce.electronic_contract' | translate}}</h3>
        <p>{{'content-introduce.electronic_contract_detail' | translate}}</p>
      </div>
    </div>
    <div class="row mt-5 text-center">
      <div class="col-3">
        <figure><img alt="time" src="./assets/images/icon1artboard_1_copy_10.png" width="100" height="100"></figure>
        <h5>{{'content-introduce.time' | translate}}</h5>
      </div>
      <div class="col-3">
        <figure><img alt="cost" src="./assets/images/tinhnang2-min.png" width="100" height="100"></figure>
        <h5>{{'content-introduce.cost' | translate}}</h5>
      </div>
      <div class="col-3">
        <figure><img alt="safe" src="./assets/images/icon1artboard_1_copy_12.png" width="100" height="100"></figure>
        <h5>{{'content-introduce.safe' | translate}}</h5>
      </div>
      <div class="col-3">
        <figure><img alt="smart" src="./assets/images/icon1artboard_1_copy_13.png" width="100" height="100"></figure>
        <h5>{{'content-introduce.smart' | translate}}</h5>
      </div>
    </div>
  </div>
  <div class="bg-grey">
    <div class="container p-4">
      <div class="row">
        <div class="col-8 offset-2 text-center">
          <h3>{{'content-introduce.why_viettel' | translate}}</h3>
          <p>{{'content-introduce.why_viettel_detail' | translate}}</p>
        </div>
      </div>
      <div class="row mt-5 text-center">
        <div class="col-4">
          <figure><img alt="trademark" src="./assets/images/ic-01.png" width="100" height="100"></figure>
          <h5>{{'content-introduce.trademark' | translate}}</h5>
          <p>{{'content-introduce.trademark_detail' | translate}}</p>
        </div>
        <div class="col-4">
          <figure><img alt="infrastructure" src="./assets/images/ic-02.png" width="100" height="100"></figure>
          <h5>{{'content-introduce.infrastructure' | translate}}</h5>
          <p>{{'content-introduce.infrastructure_detail' | translate}}</p>
        </div>
        <div class="col-4">
          <figure><img alt="deployment" src="./assets/images/ic-03.png" width="100" height="100"></figure>
          <h5>{{'content-introduce.deployment' | translate}}</h5>
          <p>{{'content-introduce.deployment_detail' | translate}}</p>
        </div>
      </div>
      <div class="row mt-3 text-center">
        <div class="col-4 offset-2">
          <figure><img alt="system" src="./assets/images/ic-04.png" width="100" height="100"></figure>
          <h5>{{'content-introduce.system' | translate}}</h5>
          <p>{{'content-introduce.system_detail' | translate}}</p>
        </div>
        <div class="col-4">
          <figure><img alt="service" src="./assets/images/ic-05.png" width="100" height="100"></figure>
          <h5>{{'content-introduce.service' | translate}}</h5>
          <p>{{'content-introduce.service_detail' | translate}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container p-4">
    <div class="row">
      <div class="col-8 offset-2 text-center">
        <h3>{{'content-introduce.how' | translate}}</h3>
        <p>{{'content-introduce.how_detail' | translate}}</p>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="footer py-3">
    <div class="container">
      <div class="row">
        <div class="col-6">
          <h4>{{'footer.contact' | translate}}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <p>{{'footer.hot_line' | translate}} 1800-8000 {{'footer.bran_2' | translate}}<br>Email:
            viettel_scontract@viettel.com.vn</p>
          <p>{{'footer.text_owner' | translate}} {{'footer.paper' | translate}}</p>
        </div>
        <div class="col-6 text-right">
          <p>{{'footer.copy-right_telecom' | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</section>
